export default {
    methods: {
        isArtworkObsolete(artwork = this.artwork) {
            var layouts = ["L9", "TT"];
            if (artwork.type == "axes" && (
                (artwork.format == "single" && layouts.includes(artwork.layout)) ||
                (["double", "vdouble"].includes(artwork.format) && (layouts.includes(artwork.layout) || layouts.includes(artwork.rightLayout))) ||
                (artwork.format == "triple" && (layouts.includes(artwork.layout) || layouts.includes(artwork.tripleRightLayout)))
            )) {
                return true;
            } else if (artwork.type == "aria" && (
                (artwork.format == "single" && artwork.layout == 'TT') ||
                (["double", "vdouble"].includes(artwork.format) && (artwork.layout == 'TT' || artwork.rightLayout == 'TT')) ||
                (artwork.format == "triple" && (artwork.layout == 'TT' || artwork.tripleRightLayout == 'TT'))
            )) {
                return true;
            }
            return false;
        }
    }
};